import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip } from '@src/components/Tooltip';
import FrCopySvg from '@src/svgs/fr-copy.svg';
import LinkSvg from '@src/svgs/fr-link.svg';
import './styles.scss';

export function Copy({ text, onCopy }) {
  const copyInputRef = useRef(null);

  return (
    <div className="copy">
      <input className="copy__input" defaultValue={text} ref={copyInputRef} type="text" />

      <Tooltip placement="bottom" overlay="Copy to clipboard">
        <CopyToClipboard onCopy={onCopy} text={text}>
          <Svg className="copy__icon" src={FrCopySvg} />
        </CopyToClipboard>
      </Tooltip>
    </div>
  );
}

export function CopyLink({ url, onCopy }) {
  const [copyStatus, setCopyStatus] = useState(false);

  return (
    <CopyToClipboard
      onCopy={() => {
        setCopyStatus(true);
        onCopy();
      }}
      text={url}
    >
      <div className="copy-link">
        <Svg className="copy-link__icon" src={LinkSvg} />
        {!copyStatus ? 'Copy opening link' : 'Link copied'}
      </div>
    </CopyToClipboard>
  );
}

Copy.propTypes = {
  onCopy: PropTypes.func,
  text: PropTypes.string,
};

CopyLink.propTypes = {
  onCopy: PropTypes.func,
  url: PropTypes.string,
};
